
module dg.objects {
   
    angular.module('dg.objects').component('dlLayout', {
        bindings: {
            propertyId: '@',
            options: '<?'
        },
        require: {
            ObjectDisplayerController: '^objectDisplayer'
        },
        controller: DisplayLayoutController,
        templateUrl: '/digmo/src/objects/properties/layouts/dl-layout.html'
    });
}